<template>
  <div class="icon-card">
    <Image v-if="content.icon" :source="content.icon" class="icon-card__icon" />
    <h3 class="small-title">{{ content.title }}</h3>
    <p>{{ content.description }}</p>
  </div>
</template>

<script>
import { Image } from '@/components/global'

export default {
  name: 'IconCard',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: { Image },
}
</script>
